export default __webpack_public_path__ + "static/media/RETRACTABLE-PATIO-ENCLOSURE-LONAVALA.c5c95962.jpg";